import { AddHookContainer as AddHook } from './AddHookContainer'

// eslint-disable-next-line import/no-default-export
export default AddHook
